import React, { useState, useEffect } from "react";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import Loader from "react-loader-spinner";
export const CircularLoader = (props) => {
  //other logic
  const [active, setActive] = useState(true);
  return (
    <div
      style={{
        zIndex: "1",
        marginTop: "10px",
        position: "relative",
        textAlign: "center",
      }}
    >
      <Loader
        type="Puff"
        color="#187de4"
        height={props ? props?.height : 100}
        width={props ? props?.width : 100}
        timeout={10000000} //100 secs
        className={props.className}
      />
    </div>
  );
};
